(() => {
  let pending=null,auth=null;
  async function list() {
    const token=localStorage.getItem('publicAuthToken');
    if(!token)return {items:[]};
    if(token!==auth){pending=null;auth=token;}
    return pending ||= fetch((window.getApiUrl?.()||window.publicAuth?.apiBaseUrl)+'/roundups',{cache:'no-store',headers:{Authorization:'Bearer '+token}})
      .then(r=>r.ok?r.json():{items:[]}).catch(()=>({items:[]}));
  }
  window.LIHRoundups={list};
  function register(){
    if(!window.Vue||Vue.options.components['roundup-link'])return;
    Vue.component('roundup-link',{
      props:{gameId:{default:null},playerId:{default:null},compact:{default:false}},
      data:()=>({roundups:null}),
      async created(){this.roundups=await list();},
      render(h){
        if(!this.roundups||this.playerId&&Number(this.playerId)!==this.roundups.player_id)return h();
        const item=this.gameId?this.roundups.items.find(i=>i.game_id===Number(this.gameId)):this.roundups.items[0];
        if(!item)return h();
        return h('a',{class:['roundup-entry',{'roundup-entry-compact':this.compact}],attrs:{href:item.href},on:{click:e=>e.stopPropagation()}},[
          h('span',{class:'roundup-entry-icon',attrs:{'aria-hidden':'true'}},'↗'),
          h('span',[h('strong',item.completed_at?'Replay my roundup':'View my roundup'),...(!this.compact?[h('small',item.home+' '+item.home_score+'–'+item.away_score+' '+item.away)]:[])])
        ]);
      }
    });
  }
  register();document.addEventListener('DOMContentLoaded',register,{once:true});
})();
